import { useGetAuthMe } from "@birdwatch/client";
import { RedirectToSignIn, useUser } from "@clerk/clerk-react";
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { LoadingOverlay } from "@/components/ui/loading-overlay";
import { APP_ROUTERS } from "@/constants/app-routers";
import { usePresaleResume } from "@/features/shared/presale";
import { getUserRole } from "@/libs/user-role";

export const Route = createFileRoute("/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { isSignedIn, isLoaded } = useUser();

  const { data: me, isPending } = useGetAuthMe().get();

  const { isManager, isOwner, isTechnician, isEvaluator, isAdmin } =
    getUserRole(me?.roles || []);

  // A presale buyer who signed in normally rather than through the funnel: `/` is where
  // every sign-in with no `redirect_url` lands, so it is the one place to catch them.
  // Gated on `isOwner` — which is false while `/auth/me` is pending — so office and admin
  // users issue no request for it.
  const { resume, isResolving: isResolvingResume } = usePresaleResume({
    enabled: isOwner,
  });

  if (!isLoaded || isPending) {
    return <LoadingOverlay />;
  }

  if (!isSignedIn) {
    return <RedirectToSignIn />;
  }

  // Already signed in then check role

  // if (isAdmin) {
  //   return <Navigate to="/admin/service-areas" />;
  // }

  if (isAdmin || isManager || isTechnician || isEvaluator) {
    return <Navigate to="/office/tasks" />;
  }

  if (isOwner) {
    if (isResolvingResume) {
      return <LoadingOverlay />;
    }
    if (resume) {
      // `replace` on both: without it, Back returns to `/`, which re-decides and pushes
      // forward again — the user can never navigate away.
      return (
        <Navigate to={APP_ROUTERS.PRESALE_CHECKOUT} search={resume} replace />
      );
    }
    return <Navigate to={APP_ROUTERS.MY_HOME} replace />;
  }

  return null;
}
